import { useMemo as i } from "react";
import { useLocalLogic as b } from "./context.js";
const p = (e, t = "en-US", o = "USD") => new Intl.NumberFormat(t, { style: "currency", currency: o }).format(e ?? 0), f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCurrency: p
}, Symbol.toStringTag, { value: "Module" })), c = (e) => typeof e == "object" && e !== null && !Array.isArray(e);
function a(e, ...t) {
  if (!t.length)
    return e;
  const o = t.shift();
  return c(e) && c(o) && Object.keys(o).forEach((r) => {
    c(o[r]) ? (e[r] || Object.assign(e, { [r]: {} }), a(e[r], o[r])) : Object.assign(e, { [r]: o[r] });
  }), a(e, ...t);
}
const m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isObject: c,
  mergeDeep: a
}, Symbol.toStringTag, { value: "Module" })), y = (e, t, o) => t === 1 ? e : o ?? `${e}s`, j = (e) => e.charAt(0).toUpperCase() + e.slice(1), g = ({
  houseNumber: e,
  street: t,
  city: o,
  state: r,
  country: n,
  postalCode: u,
  description: d
}) => [`${e ? `${e && t ? `${e} ` : `${e}`}` : ""}${t || ""}`, o, r, n, u].reduceRight((s, l) => s && l ? `${l}, ${s}` : l || s || "") || "", _ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: j,
  formatAddress: g,
  pluralize: y
}, Symbol.toStringTag, { value: "Module" })), O = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  number: f,
  object: m,
  string: _
}, Symbol.toStringTag, { value: "Module" })), h = (e) => {
  var n;
  const { client: t } = b(), o = (n = t == null ? void 0 : t.options) != null && n.locale ? t.options.locale : "en", r = i(() => O.object.mergeDeep(
    {},
    ...e
  )[o], [o, e]);
  return {
    locale: o,
    translations: r
  };
};
export {
  O as n,
  h as u
};
